import { Link } from 'react-router-dom'
import {
  VStack,
  Heading,
  Stack,
  Button,
  Box,
  Image,
  Divider,
  useMediaQuery
} from '@chakra-ui/react'

const quilmesImages = require.context('../../assets/images', true)

const Error404 = () => {
  const [isLargerThan768] = useMediaQuery('(min-width: 780px)')

  return (
    <Stack alignItems={'center'} justifyContent={'center'} mx={'auto'}>
      <Box padding={4}>
        <Image
          alt='quilmes'
          h={'auto'}
          src={quilmesImages('./logo.svg')}
          w={'auto'}
        />
      </Box>
      <Divider />
      <VStack
        alignItems={'center'}
        mx='auto'
        paddingTop={12}
        w={{ base: '90%', md: '100%' }}
      >
        <Heading
          color={'#3B3939'}
          fontWeight={800}
          {...(isLargerThan768
            ? { fontSize: '32px' }
            : { fontSize: '24px', textAlign: 'center' })}
        >
          ¡Ups! No encontramos esta página.
        </Heading>
        <Image
          paddingTop={6}
          src={quilmesImages('./404.svg')}
          {...(isLargerThan768 ? { w: 'auto' } : { w: '75%' })}
        />
        <Stack w={{ base: '100%', md: 500 }}>
          <Button
            colorScheme='teal'
            mx={'auto'}
            type='submit'
            variant='btn-quilmes'
            {...(isLargerThan768
              ? { w: '35%', marginTop: '2rem' }
              : { w: '75%', marginTop: '5rem' })}
          >
            <Link to='/'>Ir al inicio</Link>
          </Button>
        </Stack>
      </VStack>
    </Stack>
  )
}

export default Error404
